import {DetailedHTMLProps, forwardRef, InputHTMLAttributes} from "react";

export type InputProps = {
    id: string;
    name: string;
    label: string;
    type?: 'text'|'password'|'email'|'number';
    className?:string;
} & DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>

const Input = forwardRef<HTMLInputElement, InputProps>((props,ref) => {
    return (
        <input {...props} ref={ref} id={props.id} name={props.name} type={props.type} aria-label={props.label} placeholder={props.placeholder} className={`px-4 w-full py-3 bg-transparent shadow dark:border border-cardGray placeholder-cardGray dark:text-white dark:border-slate-600 rounded ${props.className}`}/>
    )
})

export default Input;